export default {
  async enroll(config = {}) {
    return await this.$post({
      url: `${this.$baseurl}/admin/promos/airtel/free-data`,
      headers: this.headers,
      ...config,
    });
  },
};
